import type { CompanyUser } from '@/lib/types/mise/company';

/** 一括 ON で新たに ON になるもの */
export interface HubAccessEnableCount {
  /** OFF のスイッチを 1 つ以上持つユーザーの数 */
  userCount: number;
  /** OFF になっている（ユーザー, アカウント）の組の数 */
  switchCount: number;
}

/**
 * 一覧のスイッチのうち、一括 ON で OFF から ON に変わる数を数える（確認ダイアログの説明用）。
 * 一括 ON はその企業のアカウントだけを ON にするため、企業外のアカウントは数えない。
 */
export function countHubAccessToEnable(
  users: CompanyUser[],
  companyAccountIds: string[],
): HubAccessEnableCount {
  const companyAccounts = new Set(companyAccountIds);
  let userCount = 0;
  let switchCount = 0;
  for (const user of users) {
    const offCount = user.account_ids.filter(
      (accountId) =>
        companyAccounts.has(accountId) && !user.hub_access_enabled_account_ids.includes(accountId),
    ).length;
    if (offCount > 0) {
      userCount += 1;
      switchCount += offCount;
    }
  }
  return { userCount, switchCount };
}
